import { useNavigate } from 'react-router-dom';

const DoctorAvailabilityReminderModal = ({ onClose }) => {
    const navigate = useNavigate();

    const handleConfigure = () => {
        onClose();
        navigate('/doctor/configuracion-citas', { state: { scrollToDisponibilidad: true } });
    };

    return (
        <div className="fixed inset-0 z-[110] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div
                className="max-w-md w-full bg-white rounded-2xl shadow-xl border border-gray-200 p-8 text-center"
                role="dialog"
                aria-modal="true"
                aria-labelledby="availability-reminder-title"
            >
                <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-emerald-100 flex items-center justify-center">
                    <svg className="w-8 h-8 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>
                <h2 id="availability-reminder-title" className="text-xl font-bold text-gray-800 mb-2">
                    ¡Tu perfil ha sido verificado!
                </h2>
                <p className="text-gray-600 text-sm mb-2">
                    ¡Te damos la bienvenida a REDPLIKA! Ya haces parte de nuestra comunidad de profesionales.
                </p>
                <p className="text-gray-600 text-sm mb-2">
                    Activa tu disponibilidad para que puedan agendar contigo en configuración de citas.
                </p>
                <p className="text-gray-500 text-xs mb-6">
                    ¡Explora la comunidad y activa esta opción cuando desees!
                </p>
                <button
                    type="button"
                    onClick={handleConfigure}
                    className="w-full py-3 px-4 bg-[#1f94c2] hover:bg-[#1a7ba8] text-white font-semibold rounded-xl transition-colors"
                >
                    Configurar disponibilidad
                </button>
                <button
                    type="button"
                    onClick={onClose}
                    className="mt-3 w-full py-2 px-4 text-gray-600 hover:text-gray-800 text-sm font-medium"
                >
                    Recordármelo después
                </button>
            </div>
        </div>
    );
};

export default DoctorAvailabilityReminderModal;
